import { render, staticRenderFns } from "./section-suggestion.vue?vue&type=template&id=3c2156dc&scoped=true"
import script from "./section-suggestion.vue?vue&type=script&lang=js"
export * from "./section-suggestion.vue?vue&type=script&lang=js"
import style0 from "./section-suggestion.vue?vue&type=style&index=0&id=3c2156dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2156dc",
  null
  
)

export default component.exports